import { render, staticRenderFns } from "./home-cjwt.vue?vue&type=template&id=fba545a0&scoped=true&"
import script from "./home-cjwt.vue?vue&type=script&lang=js&"
export * from "./home-cjwt.vue?vue&type=script&lang=js&"
import style0 from "./home-cjwt.vue?vue&type=style&index=0&id=fba545a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba545a0",
  null
  
)

export default component.exports